<template>
  <div class="">
    <h5 class="dialogTitle margin-bottom-0" v-show="!isHieuChinh">
      Ban hành văn bản
    </h5>
    <el-form
      ref="form"
      :model="form"
      :rules="validationRules"
      label-position="top"
    >
      <el-form-item
        class="input-no__label input-header__title input-header__docs"
        prop="quote"
      >
        <label class="label">Trích yếu</label>
        <el-input
          v-model="quote"
          type="textarea"
          autosize
          resize="none"
          placeholder="Nhập trích yếu văn bản"
          maxlength="2000"
          :class="[
            'input-border__radius__0',
            quote ? 'has-border__bottom' : 'input-border__bottom',
            'input-border__bottom'
          ]"
          size="medium"
          disabled
        />
      </el-form-item>

      <el-row :gutter="12" class="">
        <el-col :span="12">
          <el-form-item label="Chọn sổ đi" prop="bookId">
            <el-select
              :disabled="isDaBanHanh || isChonSo || isAddIssuedBookNumber"
              clearable
              filterable
              v-model="form.bookId"
              size="medium"
              placeholder="-"
              class="style-fullWidth input-border__bottom input-border__radius__0"
              @change="bookIdChange"
            >
              <el-option
                v-for="item in books"
                :label="item.bookName"
                :key="item.id"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="-" class="none-label">
            <el-button
              :disabled="isDaBanHanh"
              class="btnSolid__blue width__100"
              size="medium"
              @click="isOpenDialogAddBookNumber = true"
            >
              <i class="fas fa-mouse-pointer"></i>
              &nbsp;Chọn số đã book
            </el-button>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="-" class="none-label">
            <el-button
              :disabled="isDaBanHanh"
              class="btnSolid__blue width__100"
              size="medium"
              @click="changeNumberBooked"
            >
              <i class="fas fa-mouse-pointer"></i>
              &nbsp;Chọn số đã ban hành
            </el-button>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24" class="">
        <el-col :span="4">
          <el-form-item label="Số đi" prop="bookNumber">
            <el-input
              :disabled="isDaBanHanh || isChonSo || isAddIssuedBookNumber"
              class="style-fullWidth input-border__bottom input-border__radius__0"
              v-model="form.bookNumber"
              @change="bookNumberChange"
              size="medium"
              placeholder="-"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="4" v-if="isAddIssuedBookNumber">
          <el-form-item label="Số phụ" prop="subBookNumber">
            <el-select
              class="style-fullWidth input-border__bottom input-border__radius__0"
              size="medium"
              v-model="form.subBookNumber"
              clearable
              @change="subBookNumberChange"
            >
              <el-option
                v-for="item in alphaBetSource"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="9">
          <el-form-item label="Số ký hiệu" prop="docCode">
            <el-input
              :disabled="isDaBanHanh && (isAddIssuedBookNumber && !isVinataba)"
              class="style-fullWidth input-border__bottom input-border__radius__0"
              v-model="form.docCode"
              size="medium"
              placeholder="-"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="7">
          <el-form-item label="Ngày văn bản" prop="docDate">
            <el-date-picker
              :disabled="isDaBanHanh || isChonSo || (isAddIssuedBookNumber && !isVinataba)"
              class="style-fullWidth input-border__bottom input-border__radius__0"
              v-model="form.docDate"
              type="date"
              :prefix-icon="' '"
              placeholder="dd/mm/yyyy"
              size="medium"
              format="dd/MM/yyyy"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="tenantCode !== 'vinatabatrading.com.vn'">
        <el-col :span="11" v-if="!isDaBanHanh">
          <el-form-item label="Mã định danh văn bản" prop="identificationCode">
            <el-input
              disabled="disabled"
              class="style-fullWidth input-border__bottom input-border__radius__0"
              v-model="form.identificationCode"
              size="medium"
              placeholder="-"
            ></el-input>
          </el-form-item>
        </el-col>

      </el-row>
      <div class="select-Unit-BanHanh">
        <!--ban hành đến (đơn vị bên trong)-->
        <div class="label flex-row flex__left">
          Ban hành đến (đơn vị bên trong)
        </div>
        <div class="margin-bottom-10">
          <el-table
            ref="receiversDataTable"
            :data="receiversDataInfo"
            size="mini"
            style="width: 100%"
            stripe
          >
            <el-table-column
              align="center"
              header-align="center"
              type="index"
              width="50"
            ></el-table-column>
            <el-table-column
              label="Người/Đơn vị được chuyển "
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div
                  v-if="scope.row.userDeptRole"
                  class="flex-row flex__left user_selected"
                >
                  <div class="flex-row lex__left">
                    <!--                    <div class="avatar_fake flex-row flex__center">-->
                    <!--                      <span>{{buildShortName(scope.row.fullName)}}</span>-->
                    <!--                    </div>-->
                    <div class="info margin-left-10">
                      <p class="people__name margin-0">
                        {{ scope.row.userDeptRole.fullName }}
                      </p>
                      <p class="people__position margin-0">
                        {{ scope.row.userDeptRole.positionName }} -
                        {{ scope.row.userDeptRole.deptName }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="unit_selected" v-else>
                  <span class="margin-left-10">{{
                    scope.row.department.deptName
                  }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="isVinataba" header-align="center" align="center" width="260">
              <template #header>
                <span class="margin-0 item flex-col flex__center">
                  <span class="margin-bottom-5">Mức độ xử lý</span>
                </span>
              </template>
              <template slot-scope="scope">
                <div v-if="scope.row.processType === 0">
                  <span class="margin-left-10">
                    Chủ trì
                  </span>
                </div>
                <div v-else>
                  <span class="margin-left-10">
                    Nhận để biết
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="!isVinataba" header-align="center" align="center" width="60">
              <template #header>
                <span class="margin-0 item flex-col flex__center">
                  <span class="margin-bottom-5">Chủ trì</span>
                  <span>
                    <el-radio
                      class="hidden-label-radio"
                      v-model="processType"
                      :label="PROCESS_TYPE.CHUTRI"
                      @change="checkAllProcessType"
                    >
                    </el-radio>
                  </span>
                </span>
              </template>
              <template slot-scope="scope">
                <span class="item flex-col flex__center">
                  <el-radio
                    class="item txt-center hidden-label-radio"
                    v-model="scope.row.processType"
                    :label="PROCESS_TYPE.CHUTRI"
                    @change="refreshProcessType()"
                  >
                  </el-radio>
                </span>
              </template>
            </el-table-column>
            <el-table-column v-if="!isVinataba" header-align="center" align="center" width="80">
              <template #header>
                <span class="margin-0 item flex-col flex__center">
                  <span class="margin-bottom-5">Phối hợp</span>
                  <span>
                    <el-radio
                      class="hidden-label-radio"
                      :label="PROCESS_TYPE.PHOIHOP"
                      v-model="processType"
                      @change="checkAllProcessType"
                    >
                    </el-radio>
                  </span>
                </span>
              </template>
              <template slot-scope="scope">
                <el-radio
                  class="item txt-center hidden-label-radio"
                  v-model="scope.row.processType"
                  :label="PROCESS_TYPE.PHOIHOP"
                  @change="refreshProcessType()"
                >
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column v-if="!isVinataba" header-align="center" align="center" width="120">
              <template #header>
                <span class="margin-0 item flex-col flex__center">
                  <span class="margin-bottom-5">Nhận để biết</span>
                  <span>
                    <el-radio
                      class="hidden-label-radio"
                      :label="PROCESS_TYPE.NHANDEBIET"
                      v-model="processType"
                      @change="checkAllProcessType"
                    >
                    </el-radio>
                  </span>
                </span>
              </template>
              <template slot-scope="scope">
                <el-radio
                  class="item txt-center hidden-label-radio"
                  v-model="scope.row.processType"
                  :label="PROCESS_TYPE.NHANDEBIET"
                  @change="refreshProcessType()"
                >
                </el-radio>
              </template>
            </el-table-column>
            <el-table-column align="right" header-align="right" width="60">
              <template slot-scope="scope">
                <i
                  class="el-icon-circle-close clickable font-size__large color__red"
                  @click="removeReceiversData(scope.row)"
                ></i>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            class="btnPlain margin-top-10 margin-bottom-10"
            @click="openSelectReceiverDialog"
          >
            <i class="fas fa-plus-circle"></i>
            Thêm đơn vị
          </el-button>
        </div>
        <!--ban hành đến (đơn vị bên trong):end-->

        <!--ban hành đến (trục liên thông văn bản)-->
        <el-row :gutter="12" v-if="isEnableBanHanhTrucLienThong">
          <el-col :span="24">
            <el-form-item
              label="Nơi nhận bên ngoài (trục liên thông văn bản)"
              prop="insideReceiver"
            >
              <el-select
                v-model="form.tltvbAgencyIds"
                multiple
                filterable
                allow-create
                default-first-option
                remote
                reserve-keyword
                :remote-method="searchAgencies"
                :loading="isLoadingAgencies"
                size="medium"
                class="style-fullWidth input-border__bottom input-border__radius__0"
                placeholder="Nhập tên đơn vị để tìm kiếm"
              >
                <el-option
                  v-for="(item, index) in tltvbAgencies"
                  :key="index"
                  :label="`${item.name} (${item.code} - ${item.mail})`"
                  :value="item.uuid"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!--ban hành đến (trục liên thông văn bản)-->

        <!--thêm đơn vị LT-->
        <el-row :gutter="12" v-if="isEnableSmoTlt">
          <el-col :span="24">
            <el-form-item label="Nơi nhận (trục liên thông nội bộ)" prop="donViLTs">
              <el-select
                v-model="donViLTs"
                multiple
                filterable
                allow-create
                default-first-option
                remote
                :reserve-keyword="false"
                :remote-method="getListDeptTlt"
                :loading="isLoading"
                class="style-fullWidth input-border__bottom input-border__radius__0"
              >
                <el-option
                  v-for="(item, index) in listdonViLT"
                  :key="index"
                  :label="item.deptNameTo"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!--nơi nhận bên ngoài-->
        <el-row :gutter="12">
          <el-col :span="24">
            <el-form-item label="Nơi nhận bên ngoài" prop="insideReceiver">
              <el-select
                v-model="insideReceiver"
                multiple
                filterable
                allow-create
                default-first-option
                remote
                reserve-keyword
                :remote-method="remoteMethod"
                :loading="isLoading"
                class="style-fullWidth input-border__bottom input-border__radius__0"
              >
                <el-option
                  v-for="(item, index) in listInsideReceiver"
                  :key="index"
                  :label="item.deptName"
                  :value="item.deptName"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!--nơi nhận bên ngoài:end-->

        <!--người nhận-->
        <div class="label flex-row flex__left">
          Người nhận
        </div>
        <div class="margin-bottom-10">
          <el-table
            ref="receiversDataTable"
            :data="selectedToUsers"
            size="mini"
            style="width: 100%"
            stripe
          >
            <el-table-column
              align="center"
              header-align="center"
              type="index"
              width="50"
            ></el-table-column>
            <el-table-column
              label="Người/Đơn vị được chuyển "
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <div class="flex-row flex__left user_selected">
                  <div class="flex-row lex__left">
                    <div class="info margin-left-10">
                      <p class="people__name margin-0">
                        {{ scope.row.fullName }}
                      </p>
                      <p class="people__position margin-0">
                        {{ scope.row.positionName }} -
                        {{ scope.row.deptName }}
                      </p>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="right" header-align="right" width="60">
              <template slot-scope="scope">
                <i
                  class="el-icon-circle-close clickable font-size__large color__red"
                  @click="removeSelectedToUsers(scope.row)"
                ></i>
              </template>
            </el-table-column>
          </el-table>
          <el-button
            class="btnPlain margin-top-10 margin-bottom-10"
            @click="isOpenSelectCCDialog = true"
          >
            <i class="fas fa-plus-circle"></i>
            Thêm người nhận
          </el-button>
        </div>
        <!--người nhận:end-->
      </div>
    </el-form>
    <dialog-add-book-number
      :isOpen="isOpenDialogAddBookNumber"
      v-if="isEnableVbBookDocCreateDialog"
      @submit="addBookNumber"
      @closed="isEnableVbBookDocCreateDialog = false"
      @closeDialog="isOpenDialogAddBookNumber = false"
    />

    <dialog-add-issued-book-number
      :isOpen="isOpenDialogAddIssuedBookNumber"
      :bookId="form.bookId"
      v-if="isEnableVbBookDocCreateDialog2"
      @submit="addIssuedBookNumber"
      @closed="isEnableVbBookDocCreateDialog2 = false"
      @closeDialog="isOpenDialogAddIssuedBookNumber = false"
    />

    <ky-token-dialog
      ref="kyTokenDialogRef"
      v-if="isEnableKyTokenDialog"
      :isOpen="isOpenKyTokenDialog"
      :vbAttachmentId="vbAttachment.id"
      :relationDocId="currentRelationDocId"
      :attachedType="attachedType"
      :isWatchingNote="false"
      :isAddSignature="true"
      :docId="docId"
      :docDate="form.docDate"
      :docCode="form.docCode"
      :publisherDept="publisherDepartment"
      :signDate="now"
      :isProcessing="isLoading"
      :isKyNgoai="isKyNgoai"
      :needToSignCa="needToSignCa"
      :nextRelationDoc="nextRelationDoc"
      :isSignOriginalDoc="isSignOriginalDoc"
      :isAddIssuedBookNumber="isAddIssuedBookNumber"
      @submit="afterAddSignature"
      @closed="isEnableKyTokenDialog = false"
      @closeDialog="isOpenKyTokenDialog = false"
    />

    <banhanh-select-receivers-dialog
      v-if="isEnableSelectReceiverDialog"
      :isOpen="isOpenSelectReceiverDialog"
      :receiversData="receiversData"
      @save="selectReceivers"
      @closed="isEnableSelectReceiverDialog = false"
      @closeDialog="isOpenSelectReceiverDialog = false"
      :docId="docId"
    >
    </banhanh-select-receivers-dialog>

    <banhanh-select-cc-dialog
      v-if="isEnableSelectCCDialog"
      :isOpen="isOpenSelectCCDialog"
      :selectedToUserIds="selectedToUserIds"
      :selectedToUserDeptRoleIds="selectedToUserDeptRoleIds"
      @save="updateSelectedToUsers"
      @closed="isEnableSelectCCDialog = false"
      @closeDialog="isOpenSelectCCDialog = false"
      :docId="docId"
      :isBanHanhOrCC="true"
    >
    </banhanh-select-cc-dialog>

    <update-tltvb-required-data-dialog
      v-if="isEnableUpdateTltvbDataDialog"
      :isOpen="isOpenUpdateTltvbDataDialog"
      @closed="isEnableUpdateTltvbDataDialog = false"
      @closeDialog="isOpenUpdateTltvbDataDialog = false"
      @success="updateTltvbDataSuccess"
      :docId="docId"
    >
    </update-tltvb-required-data-dialog>
  </div>
</template>

<script>
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import constants from "../../../constants";
import dateFormatter from "../../../filters/dateFormatter";
import errorMessageFilter from "../../../filters/errorMessageFilter";
import attachmentService from "../../../services/attachmentService";
import bookDocService from "../../../services/bookDocService";
import bookDocTypeService from "../../../services/bookDocTypeService";
import bookService from "../../../services/bookService";
import departmentService from "../../../services/departmentService";
import docInBookService from "../../../services/docInBookService.js";
import h from "../../../services/h";
import otherDepartmentService from "../../../services/otherDepartmentService";
// eslint-disable-next-line no-unused-vars
import departmentTltService from "../../../services/departmentTltService";
import outgoingDocReceiversService from "../../../services/outgoingDocReceiversService";
import outgoingDocService from "../../../services/outgoingDocService";
import signBcycpTokenService from "../../../services/signBcycpTokenService";
import signTokenService from "../../../services/signTokenService";
import tltvbAgency from "../../../services/tltvbAgencyService";
import userDeptRoleViewService from "../../../services/userDeptRoleViewService";
import vbAttachmentTokenService from "../../../services/vbAttachmentTokenService";
import vbOutgoingProcessService from "../../../services/vbOutgoingProcessService";
import KyTokenDialog from "../../common/noteDocs/ky-token-dialog";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import UpdateTltvbRequiredDataDialog from "../update-tltvb-required-data-dialog";
import BanhanhSelectCcDialog from "./banhanh-select-cc-dialog";
import BanhanhSelectReceiversDialog from "./banhanh-select-receivers-dialog";
import DialogAddBookNumber from "./dialog-add-book-number";
import DialogAddIssuedBookNumber from "./dialog-add-issued-book-number";
import VueCookies from 'vue-cookies';
import docRelationService from "../../../services/docRelationService";
import authenService from "../../../services/authenService";
import _ from "lodash";
import tenantService from "../../../services/tenantService";

export default {
  props: [
    "docId",
    "quote",
    "publisherId",
    "docStatus",
    "actionLog",
    "isHieuChinh",
    "otherReceivePlaces",
    "docTypeId",
    "deptEditorId"
  ],
  mixins: [handleRequestErrorMixin],
  components: {
    DialogAddBookNumber,
    DialogAddIssuedBookNumber,
    UpdateTltvbRequiredDataDialog,
    BanhanhSelectCcDialog,
    BanhanhSelectReceiversDialog,
    KyTokenDialog,
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    chuyenXuLyHashtag: () => import("./chuyenXuLy-hashtag.vue"),
    VuePerfectScrollbar
  },

  data() {
    let validateDocDate = (rule, value, callback) => {
      if (!value) return;
      let truncDocDate = new moment(value).startOf("day");
      let truncNow = new moment(new Date()).startOf("day");
      return truncDocDate.diff(truncNow, "d") > 0
        ? callback(new Error("Ngày văn bản không được lớn ngày hiện tại !"))
        : callback();
    };
    let validateBookNumber = (rule, value, callback) => {
      if (!value) return;
      if (isNaN(value)) {
        callback(new Error("Số đi phải là một số"));
      } else if (value < 0 || value > 1000000) {
        callback(new Error("Số đi phải nằm trong khoảng từ 0 đến 1,000,000"));
      } else {
        callback();
      }
    };

    return {
      insideReceiver: [],
      listInsideReceiver: [],
      donViLTs: [],
      listdonViLT: [],
      isLoading: false,
      departmentTree: [],
      isOpenDialogAddBookNumber: false,
      isOpenDialogAddIssuedBookNumber: false,
      isAddIssuedBookNumber: false,
      isProcessing: false,
      isEnableVbBookDocCreateDialog: false,
      isEnableVbBookDocCreateDialog2: false,
      bookDocTypes: [],
      attachedType: "",
      bookDocType: null,
      // settings: {
      //   maxScrollbarLength: 750
      // },
      search: null,
      books: [],
      book: null,
      publisherDepartment: null,
      vbAttachment: null,

      // toUsers: [],
      // toUserIds: [],
      selectedToUsers: [],
      // toUsersGroups: [],
      // toDeptIds: [],

      isOpenKyTokenDialog: false,
      isEnableKyTokenDialog: false,

      /**
       * validate khi active department-tree;
       */
      validationRules: {
        bookId: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur"
          }
        ],
        bookNumber: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur"
          },
          { validator: validateBookNumber, trigger: "blur" }
        ],
        subBookNumber: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur"
          }
        ],
        docCode: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur"
          }
        ],
        docDate: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur"
          },
          { validator: validateDocDate, trigger: "blur" }
        ]
      },

      form: {
        bookId: null,
        bookNumber: null,
        subBookNumber: null,
        docCode: null,
        departmentIds: [],
        docDate: null,
        insideReceiver: null,
        donViLTs: null,
        tltvbAgencyIds: null,
        identificationCode: null
      },

      alphaBetSource: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],

      bookDoc: null,

      DEPARTMENT: constants.DEPARTMENT,

      editorDepartment: null,
      outgoingDoc: null,
      docInBook: null,
      now: new Date(),
      receiversData: null,
      receiversDataInfo: null,

      isOpenSelectReceiverDialog: false,
      isEnableSelectReceiverDialog: false,
      isOpenSelectCCDialog: false,
      isEnableSelectCCDialog: false,

      docReceiverIds: null,
      PROCESS_TYPE: constants.PROCESS_TYPE,
      processType: null,

      tltvbAgencies: null,
      isLoadingAgencies: false,

      isEnableUpdateTltvbDataDialog: false,
      isOpenUpdateTltvbDataDialog: false,
      relationDocs: [],
      originalRelationDocs: [],
      currentRelationDocId: null,
      isSignOriginalDoc: true,
      signedVbAttachmentIdForBanHanh: [],
      isSignTokenSuccess: true,
      isEnableSmoTlt: false
    };
  },

  computed: {
    isEnableBanHanhTrucLienThong() {
      return this.publisherDepartment && this.publisherDepartment.agencyUuid;
    },
    isBanHanhTrucLienThong() {
      return this.form.tltvbAgencyIds && this.form.tltvbAgencyIds.length;
    },

    isVinataba(){
      return this.$store.getters.userDeptRole.tenantCode === constants.TENANT_CODE.VINATABA
    },

    tenantCode() {
      return this.$store.getters.userDeptRole.tenantCode;
    },

    rootDeptId() {
      return this.publisherDepartment
        ? this.publisherDepartment.parentId || this.publisherDepartment.id
        : null;
    },
    isDaBanHanh() {
      return this.docStatus === constants.OUTGOING_DOC_STATUS.DABANHANH;
    },
    needToSignCa() {
      return (
        this.publisherDepartment &&
        this.publisherDepartment.needToSignCa ===
          constants.DEPARTMENT.NEED_TO_SIGNCA.ACTIVE
      );
    },
    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },
    deptCode() {
      return this.$store.getters.userDeptRole.deptCode;
    },
    globalConfigEditNode(){
      return authenService.getGlobalConfigEditNode()
    },

    identityCode() {
      return this.$store.getters.userDeptRole.identityCode;
    },
    isKyNgoai() {
      return (
        this.outgoingDoc &&
        this.outgoingDoc.isKyNgoai === constants.OUTGOING_DOC.IS_KY_NGOAI.TRUE
      );
    },
    isChonSo() {
      return this.bookDoc != null;
    },

    selectedToUserIds() {
      return h.collect(this.selectedToUsers, item => item.id);
    },
    selectedToUserDeptRoleIds() {
      return h.collect(this.selectedToUsers, item => item.userDeptRoleId);
    },
    nextRelationDoc() {
      return this.relationDocs.length > 0;
    }
  },

  created() {
    this.initReceiversData();
    let submitDeptForm = {
      deptNameTo: ''
    };
    tenantService.findByCode(this.tenantCode)
      .then(res => {
        console.log('res.data.isEnableSmoTlt', res.data.isEnableSmoTlt)
        if (res.data.isEnableSmoTlt && res.data.isEnableSmoTlt === 'active') {
          this.isEnableSmoTlt = (this.deptCode === constants.DEPARTMENT.DEPT_CODE.TCT || this.deptCode === constants.DEPARTMENT.DEPT_CODE.CT);
          departmentTltService
            .getListDeptTlt(submitDeptForm)
            .then(res => {
              this.listdonViLT = res.data;
              this.isLoading = false;
            });
        }
      })

    console.log('getListDeptTlt_create', this.listdonViLT);
  },

  mounted() {
    this.alphaBetSource = this.alphaBetSource.map(item => {
      return { value: `${item}`, label: `${item}` };
    });

    this.loadOutgoingDoc()
      .then(() => this.loadDocInBook())
      .then(() => this.loadBooks())
      .then(
        () =>
          (this.book = this.docInBook
            ? h.find(this.books, item => item.id === this.docInBook.bookId)
            : null)
      );

    this.loadPublisher();
    this.loadEditorDept();
    // this.initDefaultToUsers();
    this.loadReceiveOtherDepts();
    this.loadReceiveAgencies();
    this.loadRelationDocs();
  },

  watch: {
    isOpenDialogAddBookNumber(newValue) {
      newValue && (this.isEnableVbBookDocCreateDialog = newValue);
    },
    isOpenDialogAddIssuedBookNumber(newValue) {
      newValue && (this.isEnableVbBookDocCreateDialog2 = newValue);
    },
    isProcessing(newValue) {
      this.$emit("processing", { isProcessing: newValue });
    },
    isOpenKyTokenDialog(newValue) {
      newValue && (this.isEnableKyTokenDialog = newValue);
    },
    isOpenSelectReceiverDialog(newValue) {
      newValue && (this.isEnableSelectReceiverDialog = newValue);
    },
    isOpenSelectCCDialog(newValue) {
      newValue && (this.isEnableSelectCCDialog = newValue);
    },
    isOpenUpdateTltvbDataDialog(newValue) {
      newValue && (this.isEnableUpdateTltvbDataDialog = newValue);
    }
  },

  methods: {
    //nếu điền số = tay & số này thuộc dải số đã book > thực hiện thông báo
    checkWithBookDoc() {
      return new Promise(resolve => {
        if (!this.form.bookNumber || !this.form.bookId || this.isDaBanHanh) {
          resolve(null);
        } else {
          bookDocService
            .findByBookNumberAndBookId(this.form.bookNumber, this.form.bookId)
            .then(response => {
              let bookDoc = response.data;
              if (bookDoc) {
                let confirmMessage = bookDoc.deptName
                  ? errorMessageFilter({
                      errorCode: "bookDoc.banhanhConfirm",
                      params: [
                        bookDoc.fromNumber,
                        bookDoc.toNumber,
                        dateFormatter(bookDoc.bookDocDate, {
                          dateFormat: constants.DEFAULT_DATE_FORMAT
                        }),
                        bookDoc.deptName
                      ]
                    })
                  : errorMessageFilter({
                      errorCode: "bookDoc.banhanhConfirm.noDeptName",
                      params: [
                        bookDoc.fromNumber,
                        bookDoc.toNumber,
                        dateFormatter(bookDoc.bookDocDate, {
                          dateFormat: constants.DEFAULT_DATE_FORMAT
                        })
                      ]
                    });

                this.$confirm(confirmMessage, {
                  confirmButtonText: "Lấy số",
                  cancelButtonText: "Tiếp tục",
                  type: "warning"
                })
                  .then(() => {
                    this.addBookNumber_(bookDoc, this.form.bookNumber);
                    resolve(bookDoc);
                  })
                  .catch(() => resolve(null));
              } else {
                resolve(null);
              }
            });
        }
      });
    },

    updateTltvbDataSuccess() {
      this.isOpenUpdateTltvbDataDialog = false;
      this.banHanh2_();
    },

    searchAgencies(query) {
      this.isLoadingAgencies = true;
      query = query.trim();
      (query
        ? tltvbAgency
            .findAllForBanHanh(query, this.docId, {
              sort: "name",
              page: 0,
              size: 100
            })
            .then(res => res.data)
        : Promise.resolve([])
      ).then(agencies => {
        this.tltvbAgencies = agencies;
        this.isLoadingAgencies = false;
      });
    },

    getListDeptTlt(query) {
      this.isLoading = true;
      let submitDeptForm = {
        deptNameTo: query
      };
      departmentTltService
        .getListDeptTlt(submitDeptForm)
        .then(res => {
          this.listdonViLT = res.data;
          this.isLoading = false;
        });
      console.log('getListDeptTlt', this.listdonViLT);
    },

    updateReceiverData(data){
      const toDepartmentIds = data.filter(item => item.department).map(item => ({...item.department, processType: item.processType}));
      const toUserIds = data.filter(item => item.userDeptRole).map(item => ({...item.userDeptRole, processType: item.processType}));
      return {
        departments: toDepartmentIds,
        userDeptRoles: toUserIds,
      };
    },

    openSelectReceiverDialog() {
      this.receiversData = this.updateReceiverData(this.receiversDataInfo);
      this.isOpenSelectReceiverDialog = true;
    },

    loadReceiveDeparts(receiverObjectType) {
      return outgoingDocReceiversService
        .findAll({ docId: this.docId, objectType: receiverObjectType })
        .then(response => response.data);
    },

    loadReceiveOtherDepts() {
      return this.loadReceiveDeparts(
        constants.RECEIVER_OBJECT_TYPE.DONVI_BENNGOAI
      ).then(
        otherReceiveDepts =>
          (this.insideReceiver = h.collect(
            h.findAll(
              otherReceiveDepts,
              item => item.isBanhanh !== constants.TRUE
            ),
            item => item.objectName
          ))
      );
    },

    loadReceiveAgencies() {
      return tltvbAgency.findAllDefaultForBanHanh(this.docId).then(response => {
        this.tltvbAgencies = response.data;
        this.form.tltvbAgencyIds = h.collect(
          this.tltvbAgencies,
          item => item.uuid
        );
      });
    },

    checkAllProcessType() {
      h.each(this.receiversDataInfo, item =>
        this.$set(item, "processType", this.processType)
      );
    },

    isOnlyProccessTypeChecked(processType) {
      return (
        this.receiversDataInfo &&
        this.receiversDataInfo.length &&
        !h.exists(
          this.receiversDataInfo,
          item => item.processType !== processType
        )
      );
    },

    refreshProcessType() {
      if (this.isOnlyProccessTypeChecked(constants.PROCESS_TYPE.CHUTRI)) {
        this.processType = constants.PROCESS_TYPE.CHUTRI;
      } else if (
        this.isOnlyProccessTypeChecked(constants.PROCESS_TYPE.NHANDEBIET)
      ) {
        this.processType = constants.PROCESS_TYPE.NHANDEBIET;
      } else if (
        this.isOnlyProccessTypeChecked(constants.PROCESS_TYPE.PHOIHOP)
      ) {
        this.processType = constants.PROCESS_TYPE.PHOIHOP;
      } else {
        this.processType = null;
      }
      // console.log(this.processType);
      // console.log(JSON.stringify(this.receiversDataInfo))
    },

    initReceiversData() {
      Promise.all([this.loadDocReceivers(), this.loadToDepartments()]).then(
        results => {
          let docReceivers = results[0];
          let toDepartments = results[1];

          let docReceiverIds = h.collect(docReceivers, item => item.objectId);
          let receiverHandler = [];

          if (docReceiverIds.length > 0) {
            h.each(toDepartments, toDept => {
              if (docReceiverIds.indexOf(toDept.id) !== -1) {
                receiverHandler.push(toDept);
              }
            });
          }

          this.receiversData = { departments: receiverHandler };
          this.populateReceiversDataInfo();
          this.refreshProcessType();
        }
      );
    },

    loadToDepartments() {
      return departmentService
        .findAllForBanHanh(this.docId)
        .then(response => response.data);
    },

    loadDocReceivers() {
      return this.loadReceiveDeparts(constants.RECEIVER_OBJECT_TYPE.DONVI);
      // return vbOutgoingDocReceiversService
      //   .findAll({docId: this.docId, objectType: constants.RECEIVER_OBJECT_TYPE.DONVI})
      //   .then(response => response.data);
    },

    selectReceivers(event) {
      this.receiversData = event.receiversData;
      this.populateReceiversDataInfo();
      this.refreshProcessType();
      this.isOpenSelectReceiverDialog = false;
    },

    updateSelectedToUsers(event) {
      this.selectedToUsers = event.selectedToUsers;
      this.isOpenSelectCCDialog = false;
    },

    removeReceiversData(receiver) {
      let index = this.receiversDataInfo.indexOf(receiver);
      if (index !== -1) {
        this.receiversDataInfo.splice(index, 1);
        if (receiver.department) {
          let receiverDeptIds = this.receiversData.departments;
          receiverDeptIds.splice(
            receiverDeptIds.indexOf(receiver.department.id),
            1
          );
        } else if (receiver.userDeptRole) {
          let receiverHandlerIds = this.receiversData.userDeptRoles;
          receiverHandlerIds.splice(
            receiverHandlerIds.indexOf(receiver.userDeptRole.id),
            1
          );
        }
      }
      this.refreshProcessType();
    },

    loadOutgoingDoc() {
      return outgoingDocService.findById(this.docId).then(response => {
        this.outgoingDoc = response.data;
        this.outgoingDoc.docDate &&
          (this.form.docDate = new Date(this.outgoingDoc.docDate));
        this.form.docCode = this.outgoingDoc.docCode;
      });
    },

    loadBookDocType() {
      return bookDocTypeService
        .findAllByBookIdAndDocTypeId(
          this.form.bookId,
          this.outgoingDoc.docTypeId
        )
        .then(response => {
          this.bookDocType = h.find(
            response.data,
            item => item.status === constants.VB_BOOK_DOC_TYPE.STATUS.ACTIVE
          );
        });
    },

    remoteMethod(query) {
      if (query !== "") {
        this.findOtherDept(query);
      } else {
        this.options = [];
      }
    },

    findOtherDept(query) {
      this.isLoading = true;
      otherDepartmentService
        .search(query, this.deptId, { sort: "count,desc", page: 0, size: 20 })
        .then(res => {
          this.listInsideReceiver = res.data;
          this.isLoading = false;
        });
    },

    addBookNumber(event) {
      this.addBookNumber_(event.bookDoc);
      this.isOpenDialogAddBookNumber = false;
      this.isAddIssuedBookNumber = false;
    },

    addBookNumber_(bookDoc, bookNumber) {
      this.bookDoc = bookDoc;
      this.form.bookId = this.bookDoc.bookId;
      this.form.docDate = new Date(this.bookDoc.bookDocDate);
      this.form.bookNumber = bookNumber || this.bookDoc.currentNumber?(this.bookDoc.currentNumber<=9&&this.bookDoc.currentNumber >= 1?
        "0"+this.bookDoc.currentNumber:this.bookDoc.currentNumber):"";
      this.book = h.find(this.books, item => item.id === this.form.bookId);
      this.generateDocCode();

      if (this.$refs.form) {
        this.$refs.form.validateField("bookId");
        this.$refs.form.validateField("docDate");
        this.$refs.form.validateField("bookNumber");
      }
    },

    addIssuedBookNumber(event) {
      this.addIssuedBookNumber_(event.bookDocNumber);
      this.isOpenDialogAddIssuedBookNumber = false;
      this.isAddIssuedBookNumber = true;
      if (this.isVinataba === true){
        this.bookDoc = null;
      }
    },

    addIssuedBookNumber_(bookDocNumber, bookNumber) {
      this.form.bookId = bookDocNumber.vbDocInBookBookId;
      this.form.docDate = new Date(bookDocNumber.docDate);
      this.form.bookNumber = bookNumber || bookDocNumber.bookNumber?(bookDocNumber.bookNumber<=9&&bookDocNumber.bookNumber >= 1?
        "0"+bookDocNumber.bookNumber:bookDocNumber.bookNumber):"";
      this.book = h.find(this.books, item => item.id === bookDocNumber.vbDocInBookBookId);
      this.generateDocCode();

      if (this.$refs.form) {
        this.$refs.form.validateField("bookId");
        this.$refs.form.validateField("docDate");
        this.$refs.form.validateField("bookNumber");
      }
    },

    isChuyenMon() {
      let currentDeptPath = this.$store.getters.userDeptRole.deptPath;
      return currentDeptPath.startsWith(
        constants.DEPARTMENT.DEPT_PATH.TCT_PATH
      );
    },

    //set mac dinh la lanh dao cua don vi thuc hien vao phan nguoi nhan;
    initDefaultToUsers() {
      return !this.isChuyenMon() || !this.deptEditorId
        ? Promise.resolve((this.selectedToUsers = null))
        : userDeptRoleViewService
            .findAllForDocOutCCDefault(this.publisherId, this.docId, {
              sort: ["positionOrder", "fullName"]
            })
            .then(response => (this.selectedToUsers = response.data));
    },

    removeSelectedToUsers(toUser) {
      this.selectedToUsers.splice(this.selectedToUsers.indexOf(toUser), 1);
    },

    loadPublisher() {
      return departmentService.findById(this.publisherId).then(response => {
        this.publisherDepartment = response.data;
      });
    },

    loadEditorDept() {
      departmentService.findById(this.deptEditorId).then(response => {
        this.editorDepartment = response.data;
      });
    },

    generateDocCode() {
      let prefix_ = this.bookDocType
        ? this.bookDocType.prefix
        : this.book
        ? this.book.prefix
        : "-";
      // console.log('vb_outgoing_doc', this.outgoingDoc);
      // console.log('editorDepartment', this.editorDepartment);
      let docTypePrefix = "";
      if (this.$store.getters.user.tenantCode === 'vinataba.com.vn') {
        let docTypeCode = (this.outgoingDoc && this.outgoingDoc.docTypeCode) ? this.outgoingDoc.docTypeCode.trim() : null;
        switch (docTypeCode) {
          case "qd":
            docTypePrefix = "QĐ-TLVN";
            break;
          case "bc":
            docTypePrefix = "BC-TLVN";
            break;
          case "tb":
            docTypePrefix = "TB-TLVN";
            break;
          case "bb":
            docTypePrefix = "BB-TLVN";
            break;
          case "hopdong":
            docTypePrefix = "HĐ-TLVN";
            break;
          case "gm":
            docTypePrefix = "GM-TLVN";
            break;
          case "hd":
            docTypePrefix = "HD-TLVN";
            break;
          case "keHoach":
            docTypePrefix = "KH-TLVN";
            break;
          case "nghiquyet":
            docTypePrefix = "NQ-TLVN";
            break;
          case "uq":
            docTypePrefix = "GUQ-TLVN";
            break;
          case "ctr":
            docTypePrefix = "CTr-TLVN";
            break;
          case "ttr":
            docTypePrefix = "TTr-TLVN";
            break;
          case "pa":
            docTypePrefix = "PA-TLVN";
            break;
          case "da":
            docTypePrefix = "ĐA-TLVN";
            break;
          case "":
            docTypePrefix = "TLVN";
            if (this.editorDepartment){
              docTypePrefix = "TLVN-" + this.editorDepartment.identityCode;
            }
            break;
          default:
            docTypePrefix = "";
            break;
        }
        // console.log("docTypePrefix", docTypePrefix);
      }
      let subBookNumber = this.form.subBookNumber ? this.form.subBookNumber : '';
      if (prefix_.charAt(0) !== "/") prefix_ = "/" + prefix_;
      let deptEditorIdentityCode = this.getIdentityCode();
      this.form.docCode =
        `${this.form.bookNumber || "-"}${subBookNumber}${prefix_}${deptEditorIdentityCode}`;
      if (docTypePrefix && docTypePrefix !== ""){
        this.form.docCode =
          `${this.form.bookNumber || "-"}${subBookNumber}/${docTypePrefix}`;
      }

      let d = new Date();
      let currentYear = d.getFullYear();
      if(this.publisherDepartment.identificationCode) {
        this.form.identificationCode = this.publisherDepartment.identificationCode +"-"
          + currentYear +"-" +this.form.docCode;
      } else {
        this.form.identificationCode = currentYear +"-" +this.form.docCode;
      }
      this.$refs.form && this.$refs.form.validateField("docCode");
    },

    getIdentityCode() {
      if (
        !this.editorDepartment ||
        !this.editorDepartment.identityCode ||
        this.editorDepartment.id === this.publisherId
      ) {
        return "";
      } else {
        return "-" + this.editorDepartment.identityCode;
      }
    },

    /**
     * ky thuc hien add anh;
     * @param cert
     * @param fileDataInBase64
     * @param index
     * @param tokenImages
     * @returns {*}
     * @private
     */
    signedWithToken2_(cert, fileDataInBase64, index, tokenImages) {
      console.log('--- signedWithToken2_ ...')
      console.log('- cert', cert)
      console.log('- fileDataInBase64', fileDataInBase64)
      console.log('- index', index)
      console.log('- tokenImages', tokenImages)
      let tokenImage = tokenImages[index];
      return new Promise((resolve, reject) => {
        signTokenService
          .signPdfV2({
            fileData: fileDataInBase64,
            certSerial: cert.Serial,
            signDate: null,
            fieldName: "",
            typeSign: "4",
            page: tokenImage.page.toString(),
            px: Math.round(tokenImage.px).toString(),
            py: Math.round(tokenImage.py).toString(),
            pw: Math.round(tokenImage.pw).toString(),
            ph: Math.round(tokenImage.ph).toString(),
            imageData: tokenImage.imageData.substring(
              "data:image/png;base64,".length
            )
          })
          .then(response3 => {
            let signResult = response3.data;
            if (signResult.Status === constants.TOKEN_CA.STATUS.SUCCESS) {
              console.log(`----- Ky thanh cong ${index} -----`)
              return resolve(
                index === tokenImages.length - 1
                  ? signResult
                  : this.signedWithToken2_(
                      cert,
                      signResult.FileDataSigned,
                      index + 1,
                      tokenImages
                    )
              );
            } else {
              this.notify(
                "Lỗi",
                errorMessageFilter({
                  errorCode: "tokenCA.signPdfError",
                  params: [signResult.ErrorDetail]
                }),
                "error",
                4000
              );
              console.log(`----- Ky loi ${index}-----`);
              console.log('signResult', signResult)
              reject(new Error("tokenCA.signPdfError"));
            }
          })
          .catch(error => {
            return reject(error)
          });
      });
    },

    banHanh(BCY_Vinataba) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.checkIsNeedUpdateForBanHanhTrucLT().then(isContinue => {
            isContinue && this.banHanh2_(BCY_Vinataba);
          });
        } else {
          this.notify("Lỗi", "Có lỗi nhập liệu !", "error", 4000);
        }
      });
    },

    banHanh2_(BCY_Vinataba) {
      // if (this.isDaBanHanh || this.isKyNgoai) {
      if (this.isDaBanHanh) {
        //trong TH đã ban hành hoặc là văn bản ký ngoài > không cần thực hiện check ký CA nữa
        this.banHanh_(null, null)
        .then((result) => {
            console.log('Ket qua ban hanh van ban:', result)
            this.message(
              "Thông báo",
              "Ban hành văn bản thành công.",
              "success",
              4000
            );
            this.$emit("success");
            this.isProcessing = false;
        })
        .catch(error => {
          this.isProcessing = false;
          this.commonHandleRequestError(error);
          throw error;
        });
      } else {
        console.log(this.publisherDepartment.caProvider);
        switch (this.publisherDepartment.caProvider) {
          case constants.DEPARTMENT.CA_PROVIDER.BAN_CYCP:
            if(BCY_Vinataba) {
              this.signedWithBcycpTokenKyCaDauVaChuKy()
            }

            else {
              this.signedWithBcycpToken()
              .then(({ vbAttachmentId }) => {
                this.banHanh_(vbAttachmentId, null)
                .then((result) => {
                  console.log('Ket qua ban hanh van ban:', result)
                  this.message(
                    "Thông báo",
                    "Ban hành văn bản thành công.",
                    "success",
                    4000
                  );
                  this.$emit("success");
                  this.isProcessing = false;
                })
                .catch(error => {
                  this.isProcessing = false;
                  this.commonHandleRequestError(error);
                  throw error;
                });
                });
            }

            break;
          case constants.DEPARTMENT.CA_PROVIDER.MOBI_CA:
          default:
            //mở popup thực hiện ký token;
            this.openKyTokenDialog();
            break;
        }
      }
    },

    //hàm ký = token của ban cycp;
    signedWithBcycpToken() {
      return attachmentService
        .insertTemporaryForBanHanhVT(this.docId)
        .then(response => response.data)
        .then(vbAttachment => {
          if(this.globalConfigEditNode)
          {
            return vbAttachmentTokenService
              .getToken4DownloadOutgoingDocForVTLanhDaoEdit(this.docId)
              .then(response => {
                return { vbAttachmentToken: response.data, vbAttachment };
              });
          }
          else {
            return vbAttachmentTokenService
              .getToken4DownloadOutgoingDocForVT(this.docId)
              .then(response => {
                return { vbAttachmentToken: response.data, vbAttachment };
              });
          }
        })
        .then(({ vbAttachmentToken, vbAttachment }) => {
          //build url download file;
          let baseUrl = constants.BASE_SERVICE_URL;
          if (baseUrl.startsWith('https', 0)){
            baseUrl = baseUrl.replace('https', 'http');
          }
          let fileUrl = `${
            baseUrl
          }vbAttachmentToken/secure/downloadFileOutgoingDocForVT?token=${
            vbAttachmentToken.token
          }&tenantCode=${VueCookies.get('TenantCode')}`;

          // let fileUrl = 'http://localhost:8099/BusinessService/vbAttachmentToken/secure/downloadFileOutgoingDocForVT';

          //build handle-url để handle sau khi ký xong file;
          let handlerCallbackUrl = `${
            baseUrl
          }vbAttachment/uploadCaCycp?token=${vbAttachmentToken.token}&docId=${
            this.docId
          }&vbAttachmentId=${vbAttachment.id}&tenantCode=${VueCookies.get('TenantCode')}`;
          console.log("fileURL", fileUrl);
          console.log("handlerCallbackUrl", handlerCallbackUrl);

          return signBcycpTokenService
            .signPdf({
              fileUrl: fileUrl,
              FileUploadHandler: handlerCallbackUrl,
              docCode: this.form.docCode,
              docDate: this.form.docDate
            })
            .then(() => {
              return { vbAttachmentId: vbAttachment.id };
            });
        });
    },
    signedWithBcycpTokenKyCaDauVaChuKy() {
      return attachmentService
        .insertTemporaryForBanHanhVT(this.docId)
        .then(response => response.data)
        .then(vbAttachment => {
          if(this.globalConfigEditNode)
          {
            return vbAttachmentTokenService
              .getToken4DownloadOutgoingDocForVTLanhDaoEdit(this.docId)
              .then(response => {
                return { vbAttachmentToken: response.data, vbAttachment };
              });
          }
          else {
            return vbAttachmentTokenService
              .getToken4DownloadOutgoingDocForVT(this.docId)
              .then(response => {
                return { vbAttachmentToken: response.data, vbAttachment };
              });
          }
        })
        .then(({ vbAttachmentToken, vbAttachment }) => {
          //build url download file;
          let baseUrl = constants.BASE_SERVICE_URL;
          if (baseUrl.startsWith('https', 0)){
            baseUrl = baseUrl.replace('https', 'http');
          }
          let fileUrl = `${
            baseUrl
          }vbAttachmentToken/secure/downloadFileOutgoingDocForVT?token=${
            vbAttachmentToken.token
          }&tenantCode=${VueCookies.get('TenantCode')}`;

          // let fileUrl = 'http://localhost:8099/BusinessService/vbAttachmentToken/secure/downloadFileOutgoingDocForVT';

          //build handle-url để handle sau khi ký xong file;
          let handlerCallbackUrl = `${
            baseUrl
          }vbAttachment/uploadCaCycpKyCaDauVaChuKy?token=${vbAttachmentToken.token}&docId=${
            this.docId
          }&vbAttachmentId=${vbAttachment.id}&tenantCode=${VueCookies.get('TenantCode')}&objectType=${constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN_WITHOUT_STAMP}&counting=${1}`;
          console.log("fileURL", fileUrl);
          console.log("handlerCallbackUrl", handlerCallbackUrl);

          signBcycpTokenService
            .signPdf({
              fileUrl: fileUrl,
              FileUploadHandler: handlerCallbackUrl,
              docCode: this.form.docCode,
              docDate: this.form.docDate
            })
            .then(() => {
              let vbAttachmentId = vbAttachment.id;
              return attachmentService
                .insertTemporaryForBanHanhVT(this.docId)
                .then(response => response.data)
                .then(vbAttachment => {
                  return vbAttachmentTokenService
                    .getToken4DownloadOutgoingDocForTokenBanCoYeuCaDauVaChuKy(this.docId, vbAttachmentId)
                    .then(response => {
                      return { vbAttachmentToken: response.data, vbAttachment };
                    });
                })
                .then(({ vbAttachmentToken, vbAttachment }) => {
                  //build url download file;
                  let baseUrl = constants.BASE_SERVICE_URL;
                  if (baseUrl.startsWith('https', 0)) {
                    baseUrl = baseUrl.replace('https', 'http');
                  }
                  let fileUrl = `${
                    baseUrl
                  }vbAttachmentToken/secure/downloadFileOutgoingDocForVT?token=${
                    vbAttachmentToken.token
                  }&tenantCode=${VueCookies.get('TenantCode')}`;

                  // let fileUrl = 'http://localhost:8099/BusinessService/vbAttachmentToken/secure/downloadFileOutgoingDocForVT';

                  //build handle-url để handle sau khi ký xong file;
                  let handlerCallbackUrl = `${
                    baseUrl
                  }vbAttachment/uploadCaCycpKyCaDauVaChuKy?token=${vbAttachmentToken.token}&docId=${
                    this.docId
                  }&vbAttachmentId=${vbAttachment.id}&tenantCode=${VueCookies.get('TenantCode')}&objectType=${constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN}&counting=${2}`;
                  console.log("fileURL", fileUrl);
                  console.log("handlerCallbackUrl", handlerCallbackUrl);

                  return signBcycpTokenService
                    .signPdf({
                      fileUrl: fileUrl,
                      FileUploadHandler: handlerCallbackUrl,
                      docCode: this.form.docCode,
                      docDate: this.form.docDate
                    })
                    .then(() => {
                      this.banHanh_(vbAttachment.id , null)
                        .then((result) => {
                          console.log('Ket qua ban hanh van ban:', result)
                          this.message(
                            "Thông báo",
                            "Ban hành văn bản thành công.",
                            "success",
                            4000
                          );
                          this.$emit("success");
                          this.isProcessing = false;
                        })
                        .catch(error => {
                          this.isProcessing = false;
                          this.commonHandleRequestError(error);
                          throw error;
                        });
                    });
                })

            });
        });
    },

    checkIsNeedUpdateForBanHanhTrucLT() {
      return new Promise(resolve => {
        if (this.isBanHanhTrucLienThong) {
          if (
            this.outgoingDoc.isLawDocument == null ||
            this.outgoingDoc.steeringType == null ||
            this.outgoingDoc.signerUserDeptRoleId == null
          ) {
            this.$confirm(
              errorMessageFilter({
                errorCode: "banhanh.confirmUpdateForBanHanhTltvbMessage"
              }),
              {
                confirmButtonText: "Bổ sung",
                cancelButtonText: "Hủy bỏ",
                type: "info"
              }
            )
              .then(() => {
                this.openUpdateTltvbRequiredDataDialog();
                resolve(false);
              })
              .catch(() => resolve(false));
          } else {
            resolve(true);
          }
        } else {
          resolve(true);
        }
      });
    },

    openUpdateTltvbRequiredDataDialog() {
      this.isOpenUpdateTltvbDataDialog = true;
    },

    populateReceiversDataInfo() {
      let receiversData = this.receiversData;
      this.receiversDataInfo = [];
      let departments = receiversData.departments;
      let userDeptRoles = receiversData.userDeptRoles;
      h.each(userDeptRoles, userDeptRole => {
        let toHandlersInfoItem = h.find(
          receiversData.userDeptRoles,
          handlerInfoItem_ =>
            handlerInfoItem_.userDeptRoleId === userDeptRole.id
        );
        this.receiversDataInfo.push({
          userDeptRole: userDeptRole,
          processType: userDeptRole.processType,
          vbStepInfoId: toHandlersInfoItem.vbStepInfoId
        });
      });
      h.each(departments, department =>
        this.receiversDataInfo.push({
          department: department,
          processType: department.processType
        })
      );

      if (this.isVinataba) {
        this.receiversDataInfo = _.orderBy(this.receiversDataInfo, 'processType');
      }
    },

    banHanh_(signedVbAttachmentId, signedWithoutStampVbAttachmentId, vbId = this.docId, isOutgoingDoc = true) {
      console.log('----- signedVbAttachmentId', signedVbAttachmentId)
      console.log('----- isOutgoingDoc', isOutgoingDoc);
      this.isProcessing = true;
      let receiverDepts = [];
      let receiverHandlers = [];
      h.each(this.receiversDataInfo, receivers => {
        if (receivers.department) {
          receiverDepts.push({
            id: receivers.department.id,
            processType: receivers.processType
          });
        } else if (receivers.userDeptRole) {
          receiverHandlers.push({
            id: receivers.userDeptRole.id,
            processType: receivers.processType,
            vbStepInfoId: receivers.vbStepInfoId
          });
        }
      });
      let submitForm = {
        bookDocId: this.bookDoc ? this.bookDoc.id : "",
        outgoingDocId: vbId,
        isOutgoingDoc: isOutgoingDoc,
        receiverDepts: receiverDepts,
        receiverHandlers: receiverHandlers,
        toUserIds: this.selectedToUserIds,
        bookId: this.form.bookId,
        bookNumber: this.form.bookNumber,
        subBookNumber: this.form.subBookNumber,
        docCode: this.form.docCode,
        insideReceiver: this.insideReceiver.join(","),
        otherDepartments: this.insideReceiver,
        docDate: this.form.docDate.getTime(),
        actionLogId: (this.actionLog && this.isHieuChinh && this.isSignOriginalDoc) ? this.actionLog.id : null,
        signedVbAttachmentId: signedVbAttachmentId,
        signedWithoutStampVbAttachmentId: signedWithoutStampVbAttachmentId,
        tltvbAgencyIds: this.form.tltvbAgencyIds,
        identificationCode: this.form.identificationCode,
        donViLTs: this.donViLTs,
      };
      return outgoingDocService
        .banHanhVanBan(submitForm)
    },

    openKyTokenDialog() {
      this.loadAttachment().then(() => (this.isOpenKyTokenDialog = true));
    },

    /**
     * ham nay dung cho TH ban hanh khong can tokien;
     */
    uploadModifiedPage(pagesData) {
      if( pagesData.length === 0 ) return Promise.resolve(true);
      console.log('pagesData', pagesData)
      return Promise.all(
        h.collect(pagesData, pageData => {
          let imageURI = pageData.pageImageData.pageImage;
          return vbOutgoingProcessService
            .uploadImageSign({
              base64: imageURI.substring(imageURI.indexOf(",") + 1),
              pageNumber: pageData.pageIndex,
              objectId: pageData.objectId,
              isAttachmentDoc: pageData.isAttachmentDoc
            })
            .then(res => res.data.id);
        })
      )
      .then(imageFileIds =>
        {
          if(this.globalConfigEditNode)
          {
            return vbOutgoingProcessService.exportFileBanHanhLanhDaoEdit(pagesData[0].objectId, {
              imageFileIds: imageFileIds,
              isMainDoc: pagesData[0].isAttachmentDoc
            })
          } else {
            return vbOutgoingProcessService.exportFileBanHanh(pagesData[0].objectId, {
              imageFileIds: imageFileIds,
              isMainDoc: pagesData[0].isAttachmentDoc
            })
          }
        }
      )
      .then(response => response);
    },

    convertPagesDataToTokenImages(pagesData, excludeShapeTypes) {
      let tokenImages = [];
      let ratio =
        constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_72_PPI /
        constants.DETAIL_DOCS_PAGE.A4_WIDTH_AT_150_PPI;
      h.each(pagesData, pageData => {
        let pageSize = pageData.pageImageData.size;
        h.each(pageData.pageImageData.shapeImages, shapeImage => {
          if (
            excludeShapeTypes &&
            excludeShapeTypes.indexOf(shapeImage.shapeType) !== -1
          )
            return;
          let shapePosition = shapeImage.position;
          let shapeSize = shapeImage.size;
          tokenImages.push({
            page: pageData.pageIndex + 1,
            px: shapePosition.x * ratio,
            py: (pageSize.height - shapePosition.y - shapeSize.height) * ratio,
            pw: (shapePosition.x + shapeSize.width) * ratio,
            ph: (pageSize.height - shapePosition.y) * ratio,
            imageData: shapeImage.orig_base64 ? shapeImage.orig_base64 : shapeImage.uri
          });
        });
      });
      return tokenImages;
    },

    getCert() {
      return signTokenService
        .getCert("")
        .then(response2 => response2.data)
        .catch(error => {
          this.notify(
            "Lỗi",
            errorMessageFilter({ errorCode: "tokenCA.error" }),
            "error",
            4000
          );
          throw error;
        });
    },

    downloadOriginalOutgoingDocForVTAsBase64() {
      return vbAttachmentTokenService
        .downloadOriginalOutgoingDocForVTAsBase64(this.docId)
        .then(response => {
          return response.data;
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    },

    downloadRelationDocForVTAsBase64() {
      return vbAttachmentTokenService.downloadRelationDocForVTAsBase64(this.currentRelationDocId)
        .then(response => {
          return response.data
        })
        .catch(error => {
          this.commonHandleRequestError(error);
          throw error;
        });
    },

    uploadSignedPdf(cert, base64String, vbId, tokenImages, objectType) {
      console.log('uploadSignedPdf...');
      console.log('cert', cert);
      console.log('base64String', base64String);
      console.log('vbId', vbId);
      console.log('tokenImages', tokenImages);
      console.log('objectType', objectType);
      return this.signedWithToken2_(cert, base64String, 0, tokenImages)
        .then(signedResult =>
          attachmentService.uploadSignedPdf(
            vbId,
            objectType,
            signedResult.FileDataSigned
          )
        )
        .then(response => response.data)
    },
    signedWithToken2(pagesData) {
      return this.getCert()
        .then(cert => {
          if(this.isSignOriginalDoc) {
            return this.downloadOriginalOutgoingDocForVTAsBase64()
              .then(base64String => {
                return {
                  cert: cert,
                  base64String: base64String
                }
              })
          } else {
            return this.downloadRelationDocForVTAsBase64()
              .then(base64String => {
                return {
                  cert: cert,
                  base64String: base64String
                }
              })
          }
        })
        .then(result => {
            if(result.cert && !(result.cert.STT && result.cert.Serial)) {
              // eslint-disable-next-line prefer-promise-reject-errors
              return Promise.reject('Dừng do không chọn chứng thư số!');
            }
            console.log(result)

            let vbId = this.currentRelationDocId ? this.currentRelationDocId : this.docId;
            console.log('vbId', vbId);

            let cert = result.cert;
            console.log('cert', cert)

            let base64String = result.base64String;
            console.log('base64String', base64String)

            let tokenImages = this.convertPagesDataToTokenImages(pagesData, null);
            console.log('tokenImages', tokenImages);
            if(tokenImages.length === 0)
              return '';

            let tokenImagesWithoutStamp = this.convertPagesDataToTokenImages(
              pagesData,
              [constants.DETAIL_DOCS_PAGE.SHAPE_TYPE.CON_DAU]
            );
            console.log('tokenImagesWithoutStamp', tokenImagesWithoutStamp);

            let attachmentObjectType = this.isSignOriginalDoc ?
                constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN :
                constants.ATTACHMENT_OBJECT_TYPE.VB_DI_DINH_KEM_SIGNED_WITH_TOKEN;
            console.log('attachmentObjectType', attachmentObjectType);

            let attachmentObjectTypeWithoutStamp = this.isSignOriginalDoc ?
                constants.ATTACHMENT_OBJECT_TYPE.VB_DI_SIGNED_WITH_TOKEN_WITHOUT_STAMP :
                constants.ATTACHMENT_OBJECT_TYPE.VB_DI_DINH_KEM_SIGNED_WITH_TOKEN_WITHOUT_STAMP;
            console.log('attachmentObjectTypeWithoutStamp', attachmentObjectTypeWithoutStamp);

            return this.uploadSignedPdf(
              cert,
              base64String,
              vbId, // vbId
              tokenImages,
              attachmentObjectType
            )
            .then(signedVbAttachment => {
              console.log('signedVbAttachment', signedVbAttachment)
              return this.uploadSignedPdf(
                cert,
                base64String,
                vbId,
                tokenImagesWithoutStamp,
                attachmentObjectTypeWithoutStamp
              ).then(signedWithoutStampVbAttachment => {
                this.isSignTokenSuccess = true;
                this.signedVbAttachmentIdForBanHanh.push({
                  signedVbAttachmentId: signedVbAttachment.id,
                  signedWithoutStampVbAttachmentId: signedWithoutStampVbAttachment.id,
                  vbId: vbId,
                  isSignOriginalDoc: this.isSignOriginalDoc
                })
                return '';
              })
              .catch(error => {
                console.log('Loi ky token van ban without stamp', error);
                this.isSignTokenSuccess = false;
                throw error;
              });
            })
            .catch(error => {
              console.log('Loi ky token van ban with stamp', error);
              this.isSignTokenSuccess = false;
              throw error;
            });
          });
    },

    afterAddSignature(event) {
      let pagesData = event.pagesData;
      this.isLoading = true;

      if (this.needToSignCa) {
        /**
         * truong hop ky bang token;
         */

          this.signedWithToken2(pagesData)
            .then(() => {
              this.isOpenKyTokenDialog = true;

              // Ký thành công thì sẽ reset lại pagesData
              this.$refs.kyTokenDialogRef.resetPagesData();

              // Ký lần lượt văn bản chính sau đó đến các văn bản đính kèm
              if (this.relationDocs.length > 0) {
                this.relationDocs = this.relationDocs.sort((a, b) => parseInt(b.attachedType) - parseInt(a.attachedType))
                this.currentRelationDocId = this.relationDocs.pop().id;
                this.attachedType = this.originalRelationDocs.filter(item => item.id === this.currentRelationDocId)[0].attachedType
                this.isSignOriginalDoc = false;
                this.isLoading = false;
              }
              // Khi đã ký thành công toàn bộ sẽ thực hiện ban hành
              else {
                if(this.isSignTokenSuccess) {
                  let banHanhPromises = [];
                  console.log('this.signedVbAttachmentIdForBanHanh', this.signedVbAttachmentIdForBanHanh)
                  h.each(this.signedVbAttachmentIdForBanHanh, item => {
                    banHanhPromises.push(
                      this.banHanh_(
                        item.signedVbAttachmentId,
                        item.signedWithoutStampVbAttachmentId,
                        item.vbId,
                        item.isSignOriginalDoc
                      )
                    )
                  });
                  Promise.all(banHanhPromises)
                  .then((result) => {
                    console.log('Ket qua ban hanh van ban 1:', result)
                    this.message(
                      "Thông báo",
                      "Ban hành văn bản thành công.",
                      "success",
                      4000
                    );
                    this.$emit("success");
                    this.isProcessing = false;
                    this.isLoading = false;
                  })
                  .catch(error => {
                    this.isProcessing = false;
                    this.isLoading = false;
                    this.commonHandleRequestError(error);
                    throw error;
                  });
                  // .then(() => {
                  //   this.isLoading = false;
                  // })
                  // .catch(error => {
                  //   console.log('Loi ban hanh:', error)
                  //   this.isLoading = false;
                  // })
                }
              }
            })
            .catch(error => {
              console.log(error + '');
              this.isLoading = false;
            });
      } else {
        /**
         * truong hop khong can ky token
         */
        if (this.relationDocs.length > 0) {
          this.currentRelationDocId = this.relationDocs.pop().id;
          this.isSignOriginalDoc = false;
          this.isLoading = false
        } else {
          console.log('Don vi ban hanh k yeu cau ky token')
          let pagesDataGroups = h.group(pagesData, pageData => {
            if(pageData.isAttachmentDoc === true && pageData.objectId === this.docId)
              return this.docId;
            let result = '';
            h.each(this.originalRelationDocs, item => {
              if(pageData.isAttachmentDoc === false && pageData.objectId === item.id)
                result = item.id;
            })
            return result;
          });

          let prm = null;
          if (pagesDataGroups.length == 0) {
            prm = Promise.resolve(true);
          } else {
            let promises = [];
            for (let index = 0; index < pagesDataGroups.length; index++) {
              promises.push(this.uploadModifiedPage(pagesDataGroups[index].items));
            }
            prm = Promise.all(promises);
          }

          prm
            .then(() => this.banHanh_(null, null))
            .then((result) => {
              console.log('Ket qua ban hanh van ban 2:', result)
              this.message(
                "Thông báo",
                "Ban hành văn bản thành công.",
                "success",
                4000
              );
              this.$emit("success");
              this.isProcessing = false;
              this.isLoading = false;
            })
            .catch(error => {
              this.isProcessing = false;
              this.isLoading = false;
              this.commonHandleRequestError(error);
              throw error;
            });
            // .then(() => {
            //   this.isLoading = false;
            //   // this.isOpenKyTokenDialog = true;
            // })
            // .catch(error => {
            //   this.isLoading = false;
            //   throw error;
            // });
        }
      }
    },

    loadAttachment() {
      if(this.globalConfigEditNode)
      {
        return attachmentService
          .findLatestVbAttachmentPdfByDoc(this.docId)
          .then(response => {
            if (response.data) {
              this.vbAttachment = response.data;
            }
          });
      }
      else {
        return attachmentService
          .findAll({
            objectId: this.docId,
            objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DI
          })
          .then(response => {
            if (response.data && response.data.length) {
              this.vbAttachment = response.data[0];
            }
          });

      }
    },

    searchTree() {
      this.$refs.departmentTree.filter(this.search);
    },

    loadDocInBook() {
      return docInBookService.findByDocId(this.docId).then(response => {
        if (response.data) {
          this.docInBook = response.data;
          this.form.bookId = this.docInBook.bookId;
          this.form.bookNumber = this.docInBook.bookNumber;
        }
      });
    },

    loadBooks() {
      return bookService
        .getAllBook(
          {
            bookType: constants.BOOK_TYPE.VB_DI,
            includeIds: this.docInBook ? [this.docInBook.bookId] : null,
            vbBookStatus: constants.VB_BOOK.STATUS.ACTIVE
          },
          { sort: "bookName,asc", page: 0 }
        )
        .then(response => (this.books = response.data));
    },

    bookIdChange() {
      this.$refs.form.validateField("bookId");
      this.checkWithBookDoc().then(bookDoc => {
        if (this.form.bookId) {
          if (bookDoc == null) {
            this.book = h.find(
              this.books,
              item => item.id === this.form.bookId
            );
            let bookN=(this.book.bookCurrentNumber || 0) + 1
            this.form.bookNumber = bookN?(bookN<=9&&bookN >= 1? "0"+bookN:bookN):"";
            ;

            this.loadBookDocType().then(() => this.generateDocCode());
          }
        } else {
          this.book = null;
          this.form.bookNumber = 0;
          this.form.docCode = null;
        }
      });
    },

    bookNumberChange() {
      if (this.form.bookNumber.length === 1) {
        // Nếu bookNumber từ 1 đến 9, thực hiện format lại thành "01" đến "09"
        this.form.bookNumber="0"+this.form.bookNumber
      }
      this.checkWithBookDoc().then(
        bookDoc => !bookDoc && this.generateDocCode()
      );
    },

    loadRelationDocs() {
        this.relationDocs = [];
        if (!this.docId) return;
        return docRelationService
          .findAll({objectId: this.docId, attachedType: this.attachedType})
          .then(response => {
            h.each(response.data, item => {
              const relationDoc = {
                id: item.id,
                objectRelateToId: item.objectRelateToId,
                docCode: item.docCode,
                quote: item.quote,
                docDate: item.docDate,
                objectTypeRelateTo: item.objectTypeRelateTo,
                relationType: item.relationType,
                attachedType: item.attachedType,
                checkedSignCA: item.checkedSignCA
              }
              if(relationDoc.checkedSignCA) {
                this.relationDocs.unshift(relationDoc);
                this.originalRelationDocs.push(relationDoc);
              }
            });
          });
    },

    subBookNumberChange() {
      this.generateDocCode();
    },

    changeNumberBooked() {
      this.$refs.form.validateField('bookId', err => {
        if(!err)
          this.isOpenDialogAddIssuedBookNumber = true;
      });

    }
  }
};
</script>

<style scoped>
.select-Unit-BanHanh .content {
  padding: 10px 15px;
  padding-bottom: 0;
  border: 1px solid #ceced2;
  border-radius: 4px;
}

.select-Unit-BanHanh .label {
  color: #2d3e4f;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 7px;
}

.select-Unit-BanHanh .content .listCompanies.scroll-scope {
  margin-top: 5px;
  height: 200px;
  position: relative;
  margin-bottom: 10px;
  width: 100%;
}

.select-Unit-BanHanh .content .listCompanies .company_item {
  margin: 10px 0;
}

.select-Unit-BanHanh .content .listCompanies .company_item .name {
  color: #2d3e4f;
  font-weight: 700;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}

.tag_select {
  box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
  transition: all 0.25s;
}

.tag_select:hover {
  transform: translateY(2px);
  text-decoration: underline;
  transition: 0.15s;
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/components/BHanhDocOut.vue